import Cookies from 'js-cookie';

export default function getAuthToken(cookies) {
  if (cookies && typeof cookies.get === 'function') {
    return cookies.get('auth_token')?.value;
  } else if (typeof window !== 'undefined') {
    return Cookies.get('auth_token');
  }

  return null;
}
